module.exports = __webpack_public_path__ + "static/media/cone.d6019fab.svg";